export default __webpack_public_path__ + "static/media/hospital-2.aafc6ba6.png";